if(typeof __WEBPACK_EXTERNAL_MODULE_48__ === 'undefined') {var e = new Error("Cannot find module \"JSZip\""); e.code = 'MODULE_NOT_FOUND';; throw e;}
module.exports = __WEBPACK_EXTERNAL_MODULE_48__;


//////////////////
// WEBPACK FOOTER
// external "JSZip"
// module id = 48
// module chunks = 0